import "./adminPanelHome.css";
import Adminpanel from "./Component/adminPanel/Adminpanel";
import { useEffect, useState } from "react";

import Unlockscreen from "./Component/unlockScreen/Unlockscreen";
import PinUnlock from "./Component/pinUnlock/PinUnlock";
import ChooseLockType from "./Component/chooseLockType/ChooseLockType";
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import { useGlobalContext } from "../Context/Context";

const AdminPanelHome = ({ account, setSelectAccount }) => {
  let currentSession = sessionStorage.getItem("unlock");

  if (currentSession === null) {
    sessionStorage.setItem("unlock", true);
    currentSession = true;
  }

  const [timeUnlockCurrent, setTimeUnlockCurrent] = useState(
    currentSession.toString() === "true" ? true : false
  );

  const [lockType, setLockType] = useState(0);
  const [timeUnlock] = useState(5 * 1000000000000);
  const [lastInteractionTime, setLastInteractionTime] = useState(0);

  const handleMouseMove = (e) => {
    setLastInteractionTime(Date.now());
  };

  const handleLockScreen = () => {
    if (timeUnlockCurrent) return;
    else {
      if (lockType === 0) {
        // 0 forma za odabir nacina otkljucavanja
        return <ChooseLockType setLockType={setLockType} />;
      }
      if (lockType === 1)
        return <Unlockscreen setTimeUnlockCurrent={setTimeUnlockCurrent} />; //1 otkljucavanje preko sablona
      if (lockType === 2)
        return <PinUnlock setTimeUnlockCurrent={setTimeUnlockCurrent} />; //2 otkljucavanje preko pina
    }
  };

  useEffect(() => {
    let timeout;
    if (timeUnlockCurrent) {
      timeout = setTimeout(() => {
        const currentTime = Date.now();
        const elapsedTime = currentTime - lastInteractionTime;

        if (elapsedTime >= timeUnlock) {
          if (timeUnlockCurrent) {
            setTimeUnlockCurrent(false);
            sessionStorage.setItem("unlock", false);
          }
        } else {
          timeout = setTimeout(() => {
            if (timeUnlockCurrent) {
              setTimeUnlockCurrent(false);
              sessionStorage.setItem("unlock", false);
            }
          }, timeUnlock - elapsedTime);
        }
      }, timeUnlock);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [timeUnlock, timeUnlockCurrent, lastInteractionTime]);

  return (
    <div
      className="admin-panel-home"
      tabIndex={0}
      //onMouseMove={(e) => handleMouseMove(e)}
      // onClick={(e) => handleMouseMove(e)}
      // onTouchMove={(e) => handleMouseMove(e)}
      //  onTouchStart={(e) => handleMouseMove(e)}
      // onTouchEnd={(e) => handleMouseMove(e)}
      // onKeyDown={(e) => handleMouseMove(e)}
    >
      <Adminpanel
        timeUnlockCurrent={timeUnlockCurrent}
        account={account}
        setSelectAccount={setSelectAccount}
      />
      {handleLockScreen()}
    </div>
  );
};

export default AdminPanelHome;


//Archive.jsx:272
